module.exports = __webpack_public_path__ + "img/locker_3.cb4178d2.png";